<article class="collection-card" [ngClass]="view"
         [attr.data-test]="'card_collection'"
         [class.mobile]="deviceService.isMobile()"
         itemscope
         itemtype="https://schema.org/Product">
  <app-collection-meta [collection]="collection"></app-collection-meta>

  <div class="card-cover" (click)="onOpenCardInModal()"></div>
  <div class="cover-wrap">
    <ng-container *ngTemplateOutlet="coverBlock"></ng-container>
    <div class="bookmark">
      <app-bookmark [notooltip]="true" [item]="collection" [type]="'collection'" (favoriteChanged)="favoriteChanged($event)"></app-bookmark>
    </div>
  </div>

  <div class="main-info-wrap">
    <div class="subject-wrap" [attr.data-test]="'card_collection_subject'" *ngIf="collection.subject?.title">
      <span class="subject bold">{{ collection.subject?.title }}</span>
      <ng-template [ngIf]="subjectIsNative">
        <span class="native normal">{{ 'library.user-service-card.native' | customLocale }}</span>
      </ng-template>
    </div>

    <ng-template [ngIf]="view === 'wide-horizontal'">
      <div class="title-block">
        <div class="title" [attr.data-test]="'card_collection_title'">
          <a [href]="collectionUrl" class="no-link">
            {{ collection.title | striptags }}
          </a>
        </div>
        <div class="materials">({{ 'collections.text.items' | customLocale }} {{ collection.stats?.total }})</div>
      </div>
    </ng-template>

    <ng-template [ngIf]="view !== 'wide-horizontal'">
      <div class="title"  [attr.data-test]="'card_collection_title'">
        <a [href]="collectionUrl" class="no-link">
          {{ collection.title | striptags }}
        </a>
      </div>
      <div *ngIf="!deviceService.isMobile()" class="excerpt">{{ collection.excerpt }}</div>
      <div class="materials">{{ 'collections.text.items' | customLocale }} {{ collection.stats?.total }}</div>
    </ng-template>

    <div class="author-block">
      <div class="avatar-wrap">
        <on-ui-cover [cover]="userAvatar"></on-ui-cover>
      </div>
      <div class="teacher-name" itemprop="author" [attr.data-test]="'card_collection_author_name'">
        <a [href]="accountRoute" class="no-link">
          {{ authorName }}
        </a>
      </div>
      <ng-container *ngTemplateOutlet="ratingWrap"></ng-container>
    </div>
    <div class="price-block">
      <ng-template [ngIf]="collection.discount">
        <div class="discount-wrap">
          <span class="price-without-discount">{{ getFormattedPrice(selectedLicensePrice, collection.discount) | async }}</span>
        </div>
      </ng-template>
      <ng-template [ngIf]="selectedLicensePrice">
        <div class="see-price-wrap">
          <span class="price"[attr.data-test]="'card_collection_price'">{{ getFormattedPrice(selectedLicensePrice) | async }}</span>
          <div class="icon-see-prices"
               [appPopover]="pricesPopoverContent"
               [popoverOnly]="true"
               [position]="position">?
          </div>
        </div>
      </ng-template>
    </div>
  </div>
</article>

<ng-template #ratingWrap>
  <app-rating [stats]="authorStats"></app-rating>
</ng-template>

<app-alert type="error"
           *ngIf="isDeleteAlertOpened"
           (closed)="onToggleDeleteAlert()">
  <ng-container alert-title>{{ 'collections-constructor.delete-confirmation.title' | customLocale }}</ng-container>
  <ng-container alert-body>
    <div [innerHTML]="'collections-constructor.delete-confirmation.text' | customLocale"></div>
  </ng-container>
  <ng-container alert-buttons>
    <on-ui-button class="primary outline"
                  label="collections-constructor.delete-confirmation.cancel"
                  (onclick)="onToggleDeleteAlert()">
    </on-ui-button>
    <on-ui-button class="primary"
                  label="collections-constructor.delete-confirmation.delete"
                  (onclick)="isDeleteAlertOpened = false">
    </on-ui-button>
  </ng-container>
</app-alert>

<ng-template #coverBlock>
  <div class="cover-block" [class.no-cover]="!multiCoverUrls.length">
    <ng-template [ngIf]="multiCoverUrls.length" [ngIfElse]="noCover">
      <div *ngFor="let coverItem of multiCoverUrls; let i = index; trackBy: trackByFn"
           class="cover-item" [class.active]="activeCoverItem === i">

        <ng-template [ngIf]="isBrowser" [ngIfElse]="noBrowser">
          <on-ui-cover [cover]="getAvatar(coverItem)" [scale]="doHover" [attr.data-test]="'card_collection_cover'" [withBlur]="true"></on-ui-cover>
        </ng-template>
        <ng-template #noBrowser>
          <img [src]="coverItem" [alt]="fullTitle" [title]="fullTitle" [attr.data-test]="'card_collection_cover'" class="cover" [class.scale]="doHover">
        </ng-template>
      </div>

      <div class="dots" *ngIf="multiCoverUrls.length > 1">
        <div class="dots-item"
             *ngFor="let coverItem of multiCoverUrls; let i = index; trackBy: trackByFn"
             [class.active]="activeCoverItem === i"
             (mouseenter)="setActiveCoverItem(i)" (click)="setActiveCoverItem(i)"></div>
      </div>
    </ng-template>
    <ng-template #noCover>
      <on-ui-cover [cover]="getAvatar()" [scale]="doHover" [attr.data-test]="'card_collection_cover'"></on-ui-cover>
    </ng-template>
  </div>
</ng-template>

<ng-template #pricesPopoverContent>
  <app-collection-license-prices [collection]="collection"></app-collection-license-prices>
</ng-template>
